/* ========================================================================== *\
   COMPONENTS - MODAL
\* ========================================================================== */

/* 
- gyModalElement must be ID
*/


function gyModal (custom) {
    const defaults = {
        gyModalElement: 'js-modal',
        gyModalShow: '.js-modal-open',
        gyModalClose: '.js-modal__close',
        targetOpenName: 'is-active',
        documentOpenName: 'is-modal-active',
        focusableElements: "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]"
    };

    const settings = {...defaults, ...custom};

    const gyModalElementNode = document.getElementById(settings.gyModalElement),
          gyModalShowNodes = document.querySelectorAll(settings.gyModalShow),
          gyModalCloseNodes = document.querySelectorAll(settings.gyModalClose);

    let isOpen = false,
        lastFocus;

    //Set accessibility attributes
    gyModalElementNode.setAttribute('aria-hidden', 'true');
    gyModalElementNode.setAttribute('role', 'dialog');
    gyModalElementNode.setAttribute('tabindex', '-1');

    function showModal(id) {
        lastFocus = document.activeElement;

        document.body.classList.add(settings.documentOpenName);

        gyModalElementNode.classList.add(settings.targetOpenName);
        gyModalElementNode.setAttribute('aria-hidden', 'false');
        gyModalElementNode.setAttribute('tabindex', '0');

        //Set focus only once visible
        gyModalElementNode.addEventListener("transitionend", (event) => {
            if (event.propertyName == "visibility") {
                gyModalElementNode.focus();
            }
        });

        isOpen = true;

        //Scroll to targeted element
        if (id) {
            gyModalElementNode.querySelector(`:scope [data-media-id="${id}"]`).scrollIntoView();
        }
    };

    function hideModal() {
        if (isOpen) {
            document.body.classList.remove(settings.documentOpenName);

            gyModalElementNode.classList.remove(settings.targetOpenName);
            gyModalElementNode.setAttribute('aria-hidden', 'true');
            gyModalElementNode.setAttribute('tabindex', '-1');

            lastFocus.focus();

            isOpen = false;
        }
    }

    function trapFocus(modal, event) {

        if (event.key == 'Tab') {
            const elements = modal.querySelectorAll(`:scope ${settings.focusableElements}`);

            function isVisible(element) {
                return window.getComputedStyle(element).getPropertyValue('display') !== 'none' && window.getComputedStyle(element).getPropertyValue('visibility') !== 'hidden';
            }

            const focusables = [...elements].filter(isVisible);
            const focusablesTotal = focusables.length;

            let currentFocus = document.activeElement;
            let currentFocusIndex = focusables.indexOf(currentFocus);

            if (event.shiftKey) {
                if (currentFocusIndex <= 0) {
                    event.preventDefault();
                    focusables[focusablesTotal - 1].focus();
                }
            } else {
                if (currentFocusIndex === focusablesTotal - 1) {
                    event.preventDefault();
                    focusables[0].focus();
                }
            }
        }

    }

    // Open
    gyModalShowNodes.forEach(element => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            showModal(element.dataset.mediaId);
        });
    });

    // Close
    gyModalCloseNodes.forEach(element => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            hideModal();
        });
    });

    // Close on Backdrop
    gyModalElementNode.addEventListener('click', (event) => {
        if (event.currentTarget == event.target) {
            hideModal();
        }
    });

    // Close on Escape
    window.addEventListener('keyup', (event) => {
        if (event.key == 'Escape') {
            hideModal();
        }
    });

    // Trap Focus
    gyModalElementNode.addEventListener('keydown', function(event) {
        trapFocus(this, event);
    });
}